// extracted by mini-css-extract-plugin
export default {"info":"styles_info__IWCzK"};